































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryTrackingRequest from '@/model/request/DeliveryTrackingRequest'
import FilterDeliveryTracking from '@/components/filters/FilterDeliveryTracking.vue'
import DeliveryTrackingResponse from '@/model/response/DeliveryTrackingResponse'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import {snakeCase} from 'lodash'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryTracking.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryTracking},
})
export default class ReportsDeliveryTrackingView extends Mixins(MixinFilter) {
  filter = new DeliveryTrackingRequest()
  collection = new PageCollection(DeliveryTrackingResponse, this.filter, 10)

  AppConfig = AppConfig

async downloadData(xlsx: boolean) {
  if (!xlsx) {
      const csv = new PageCollection(DeliveryTrackingResponse, this.filter, null, null)

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reports.deliveryTracking.title')))
  } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('view.reports.deliveryTracking.title'),
        new DeliveryTrackingResponse().$endpoint,
        this.filter,
        DeliveryTrackingResponse,
        'DeliveryTrackingResponse',
        ), 'download')
  }
}
}
